<div class="filter-group" data-group-visibility-id="showTieredGearFilters">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showTieredGearFilters" (click)="filter.groupVisibility.showTieredGearFilters = !filter.groupVisibility.showTieredGearFilters; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Unidentified Equipment" [activeRules]="activeRules.unidentifiedEquipmentFiltersPoe2">
          <app-content cid="unidentified-equipment-poe2" contentType="tip"></app-content>
        </span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showTieredGearFilters) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showTieredGearFilters">

      <div class="filter filter-property full-span" [class.disabled]="!filter.showTieredRareGear">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showTieredRareGear"
            (click)="toggleShowTieredRareGear()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Rare Gear" [additionalContent]="tieredRareGearAdditionalContent" ruleId="gear-unidentified-tier-rare-t5" [prefixMatch]="true">
            <ng-template #tieredRareGearAdditionalContent>
              @if (filter.showTieredRareGear && !isMobile()) {
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.OtherGearRareT5"
                  [active]="filter.showTieredRareGear"
                  exampleName="Rare Gear (Tier 5)"
                  [rarity]="Rarity.Rare"></app-equipment-tier-picker>

                @if (filter.showTieredRareGearMinTier <= 4) {
                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherGearRareT4"
                    [active]="filter.showTieredRareGear"
                    exampleName="Rare Gear (Tier 4)"
                    [rarity]="Rarity.Rare"></app-equipment-tier-picker>
                }
                @if (filter.showTieredRareGearMinTier <= 3) {
                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherGearRareT3"
                    [active]="filter.showTieredRareGear"
                    exampleName="Rare Gear (Tier 3)"
                    [rarity]="Rarity.Rare"></app-equipment-tier-picker>
                }
                @if (filter.showTieredRareGearMinTier <= 2) {
                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherGearRareT2"
                    [active]="filter.showTieredRareGear"
                    exampleName="Rare Gear (Tier 2)"
                    [rarity]="Rarity.Rare"></app-equipment-tier-picker>
                }
              }
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-select-gear-tier [greaterThanOrEqualTo]="true" [disabled]="!filter.showTieredRareGear" [(ngModel)]="filter.showTieredRareGearMinBaseTypeTier" (selectedValueChange)="updateFilter();"></app-select-gear-tier>
          <span class="sep"></span>
          <app-select style="width: 65px" [disabled]="!filter.showTieredRareGear" [(ngModel)]="filter.showTieredRareGearMinTier" (selectedValueChange)="updateFilter()">
            <app-option [value]="2" text="≥ T2"></app-option>
            <app-option [value]="3" text="≥ T3"></app-option>
            <app-option [value]="4" text="≥ T4"></app-option>
            <app-option [value]="5" text="T5"></app-option>
          </app-select>
          @if (filter.showTieredRareGearMinBaseTypeTier !== BaseTypeTier.Basic) {
            <span class="sep"></span>
            <div class="filter-title filter-label table-checkbox-group">
              <span class="input-group-btn">
                <button class="btn toggle-btn"
                  [class.off]="filter.showLowTierTieredRareGear === false"
                  [disabled]="!filter.showTieredRareGear"
                  (click)="toggleShowLowTierTieredRareGear()"></button>
              </span>
              <div class="table-checkbox-label">
                <span class="filter-title-text" data-filter-rule-id="gear-unidentified-tier-low-tier-rare-t5">{{ getLowerTierName(filter.showTieredRareGearMinBaseTypeTier) }}</span>
                @if (filter.showLowTierTieredRareGear && !isMobile()) {
                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherGearLowerGearTierRareT5"
                    [active]="filter.showLowTierTieredRareGear"
                    exampleName="Rare Gear (Tier 5)"
                    [rarity]="Rarity.Rare"></app-equipment-tier-picker>

                  @if (filter.showLowTierTieredRareGearMinTier <= 4) {
                    <app-equipment-tier-picker
                      [equipmentType]="EquipmentType.OtherGearLowerGearTierRareT4"
                      [active]="filter.showLowTierTieredRareGear"
                      exampleName="Rare Gear (Tier 4)"
                      [rarity]="Rarity.Rare"></app-equipment-tier-picker>
                  }
                  @if (filter.showLowTierTieredRareGearMinTier <= 3) {
                    <app-equipment-tier-picker
                      [equipmentType]="EquipmentType.OtherGearLowerGearTierRareT3"
                      [active]="filter.showLowTierTieredRareGear"
                      exampleName="Rare Gear (Tier 3)"
                      [rarity]="Rarity.Rare"></app-equipment-tier-picker>
                  }
                }
              </div>
            </div>
            <span class="sep"></span>
            <app-select style="width: 65px" [disabled]="!filter.showLowTierTieredRareGear" [(ngModel)]="filter.showLowTierTieredRareGearMinTier" (selectedValueChange)="updateFilter()">
              <app-option [value]="3" text="≥ T3"></app-option>
              <app-option [value]="4" text="≥ T4"></app-option>
              <app-option [value]="5" text="T5"></app-option>
            </app-select>
          }
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showTieredMagicGear">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showTieredMagicGear"
            (click)="toggleShowTieredMagicGear()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Magic Gear" [additionalContent]="tieredMagicGearAdditionalContent" ruleId="gear-unidentified-tier-magic-t5" [prefixMatch]="true">
            <ng-template #tieredMagicGearAdditionalContent>
              @if (filter.showTieredMagicGear && !isMobile()) {
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.OtherGearMagicT5"
                  [active]="filter.showTieredMagicGear"
                  exampleName="Magic Gear (Tier 5)"
                  [rarity]="Rarity.Magic"></app-equipment-tier-picker>

                @if (filter.showTieredMagicGearMinTier <= 4) {
                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherGearMagicT4"
                    [active]="filter.showTieredMagicGear"
                    exampleName="Magic Gear (Tier 4)"
                    [rarity]="Rarity.Magic"></app-equipment-tier-picker>
                }
                @if (filter.showTieredMagicGearMinTier <= 3) {
                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherGearMagicT3"
                    [active]="filter.showTieredMagicGear"
                    exampleName="Magic Gear (Tier 3)"
                    [rarity]="Rarity.Magic"></app-equipment-tier-picker>
                }
                @if (filter.showTieredMagicGearMinTier <= 2) {
                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherGearMagicT2"
                    [active]="filter.showTieredMagicGear"
                    exampleName="Magic Gear (Tier 2)"
                    [rarity]="Rarity.Magic"></app-equipment-tier-picker>
                }
              }
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-select-gear-tier [greaterThanOrEqualTo]="true" [disabled]="!filter.showTieredMagicGear" [(ngModel)]="filter.showTieredMagicGearMinBaseTypeTier" (selectedValueChange)="updateFilter();"></app-select-gear-tier>
          <span class="sep"></span>
          <app-select style="width: 65px" [disabled]="!filter.showTieredMagicGear" [(ngModel)]="filter.showTieredMagicGearMinTier" (selectedValueChange)="updateFilter()">
            <app-option [value]="2" text="≥ T2"></app-option>
            <app-option [value]="3" text="≥ T3"></app-option>
            <app-option [value]="4" text="≥ T4"></app-option>
            <app-option [value]="5" text="T5"></app-option>
          </app-select>
          @if (filter.showTieredMagicGearMinBaseTypeTier !== BaseTypeTier.Basic) {
            <span class="sep"></span>
            <div class="filter-title filter-label table-checkbox-group">
              <span class="input-group-btn">
                <button class="btn toggle-btn"
                  [class.off]="filter.showLowTierTieredMagicGear === false"
                  [disabled]="!filter.showTieredMagicGear"
                  (click)="toggleShowLowTierTieredMagicGear()"></button>
              </span>
              <div class="table-checkbox-label">
                <span class="filter-title-text" data-filter-rule-id="gear-unidentified-tier-low-tier-magic-t5">{{ getLowerTierName(filter.showTieredMagicGearMinBaseTypeTier) }}</span>
                @if (filter.showLowTierTieredMagicGear && !isMobile()) {
                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherGearLowerGearTierMagicT5"
                    [active]="filter.showLowTierTieredMagicGear"
                    exampleName="Magic Gear (Tier 5)"
                    [rarity]="Rarity.Magic"></app-equipment-tier-picker>

                  @if (filter.showLowTierTieredMagicGearMinTier <= 4) {
                    <app-equipment-tier-picker
                      [equipmentType]="EquipmentType.OtherGearLowerGearTierMagicT4"
                      [active]="filter.showLowTierTieredMagicGear"
                      exampleName="Magic Gear (Tier 4)"
                      [rarity]="Rarity.Magic"></app-equipment-tier-picker>
                  }
                  @if (filter.showLowTierTieredMagicGearMinTier <= 3) {
                    <app-equipment-tier-picker
                      [equipmentType]="EquipmentType.OtherGearLowerGearTierMagicT3"
                      [active]="filter.showLowTierTieredMagicGear"
                      exampleName="Magic Gear (Tier 3)"
                      [rarity]="Rarity.Magic"></app-equipment-tier-picker>
                  }
                }
              </div>
            </div>
            <span class="sep"></span>
            <app-select style="width: 65px" [disabled]="!filter.showLowTierTieredMagicGear" [(ngModel)]="filter.showLowTierTieredMagicGearMinTier" (selectedValueChange)="updateFilter()">
              <app-option [value]="3" text="≥ T3"></app-option>
              <app-option [value]="4" text="≥ T4"></app-option>
              <app-option [value]="5" text="T5"></app-option>
            </app-select>
          }
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showTieredRareJewellery">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showTieredRareJewellery"
            (click)="toggleShowTieredRareJewellery()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Rare Jewellery" [additionalContent]="tieredRareJewelleryAdditionalContent" ruleId="jewellery-unidentified-tier-rare-t5" [prefixMatch]="true">
            <ng-template #tieredRareJewelleryAdditionalContent>
              @if (filter.showTieredRareJewellery && !isMobile()) {
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.OtherJewelleryRareT5"
                  [active]="filter.showTieredRareJewellery"
                  exampleName="Iron Ring (Tier 5)"
                  [rarity]="Rarity.Rare"></app-equipment-tier-picker>

                @if (filter.showTieredRareJewelleryMinTier <= 4) {
                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherJewelleryRareT4"
                    [active]="filter.showTieredRareJewellery"
                    exampleName="Iron Ring (Tier 4)"
                    [rarity]="Rarity.Rare"></app-equipment-tier-picker>
                }
                @if (filter.showTieredRareJewelleryMinTier <= 3) {
                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherJewelleryRareT3"
                    [active]="filter.showTieredRareJewellery"
                    exampleName="Iron Ring (Tier 3)"
                    [rarity]="Rarity.Rare"></app-equipment-tier-picker>
                }
                @if (filter.showTieredRareJewelleryMinTier <= 2) {
                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherJewelleryRareT2"
                    [active]="filter.showTieredRareJewellery"
                    exampleName="Iron Ring (Tier 2)"
                    [rarity]="Rarity.Rare"></app-equipment-tier-picker>
                }
              }
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-autocomplete style="width: 150px"
            [allLabel]="'All'"
            [options]="jewelleryTypes"
            [disabled]="false"
            [showOptions]="true"
            [selectedValues]="filter.showTieredRareJewelleryTypes"
            (selectedValuesChange)="showTieredRareJewelleryTypesChanged($event);"></app-autocomplete>
          @if (!isMobile()) {
            <span class="sep"></span>
            <div class="filter-title filter-label">
              iLevel ≥
            </div>
          }
          <span class="sep"></span>
          <input type="number" placeholder="≥ ilvl" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.showTieredRareJewellery"
            [(ngModel)]="filter.showTieredRareJewelleryMinIlevel" (change)="updateFilter()">
          <span class="sep"></span>
          <app-select style="width: 65px" [disabled]="!filter.showTieredRareJewellery" [(ngModel)]="filter.showTieredRareJewelleryMinTier" (selectedValueChange)="updateFilter()">
            <app-option [value]="2" text="≥ T2"></app-option>
            <app-option [value]="3" text="≥ T3"></app-option>
            <app-option [value]="4" text="≥ T4"></app-option>
            <app-option [value]="5" text="T5"></app-option>
          </app-select>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showTieredMagicJewellery">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showTieredMagicJewellery"
            (click)="toggleShowTieredMagicJewellery()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Magic Jewellery" [additionalContent]="tieredMagicJewelleryAdditionalContent" ruleId="jewellery-unidentified-tier-magic-t5" [prefixMatch]="true">
            <ng-template #tieredMagicJewelleryAdditionalContent>
              @if (filter.showTieredMagicJewellery && !isMobile()) {
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.OtherJewelleryMagicT5"
                  [active]="filter.showTieredMagicJewellery"
                  exampleName="Magic Jewellery (Tier 5)"
                  [rarity]="Rarity.Magic"></app-equipment-tier-picker>

                @if (filter.showTieredMagicJewelleryMinTier <= 4) {
                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherJewelleryMagicT4"
                    [active]="filter.showTieredMagicJewellery"
                    exampleName="Magic Jewellery (Tier 4)"
                    [rarity]="Rarity.Magic"></app-equipment-tier-picker>
                }
                @if (filter.showTieredMagicJewelleryMinTier <= 3) {
                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherJewelleryMagicT3"
                    [active]="filter.showTieredMagicJewellery"
                    exampleName="Magic Jewellery (Tier 3)"
                    [rarity]="Rarity.Magic"></app-equipment-tier-picker>
                }
                @if (filter.showTieredMagicJewelleryMinTier <= 2) {
                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherJewelleryMagicT2"
                    [active]="filter.showTieredMagicJewellery"
                    exampleName="Magic Jewellery (Tier 2)"
                    [rarity]="Rarity.Magic"></app-equipment-tier-picker>
                }
              }
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-autocomplete style="width: 150px"
            [allLabel]="'All'"
            [options]="jewelleryTypes"
            [disabled]="false"
            [showOptions]="true"
            [selectedValues]="filter.showTieredMagicJewelleryTypes"
            (selectedValuesChange)="showTieredMagicJewelleryTypesChanged($event);"></app-autocomplete>
          @if (!isMobile()) {
            <span class="sep"></span>
            <div class="filter-title filter-label">
              iLevel ≥
            </div>
          }
          <span class="sep"></span>
          <input type="number" placeholder="≥ ilvl" maxlength="2" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.showTieredMagicJewellery"
            [(ngModel)]="filter.showTieredMagicJewelleryMinIlevel" (change)="updateFilter()">
          <span class="sep"></span>
          <app-select style="width: 65px" [disabled]="!filter.showTieredMagicJewellery" [(ngModel)]="filter.showTieredMagicJewelleryMinTier" (selectedValueChange)="updateFilter()">
            <app-option [value]="2" text="≥ T2"></app-option>
            <app-option [value]="3" text="≥ T3"></app-option>
            <app-option [value]="4" text="≥ T4"></app-option>
            <app-option [value]="5" text="T5"></app-option>
          </app-select>
        </span>
      </div>

    </div>
    <div class="clear"></div>
  }
</div>
